/**
 * Quantity input +/- button logic.
 * Works with <quantity-input> custom element.
 * This component ONLY handles incrementing/decrementing the number.
 * Cart AJAX updates are handled separately in cart.js.
 */
(function () {
  'use strict';

  if (typeof customElements === 'undefined') return;

  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity-input__field');
      this.minusBtn = this.querySelector('[name="minus"]');
      this.plusBtn = this.querySelector('[name="plus"]');

      if (!this.input) return;

      this.minusBtn && this.minusBtn.addEventListener('click', this.decrease.bind(this));
      this.plusBtn && this.plusBtn.addEventListener('click', this.increase.bind(this));
      this.input.addEventListener('change', this.validate.bind(this));
    }

    get min() {
      return parseInt(this.input.min) || 0;
    }

    get max() {
      return parseInt(this.input.max) || 9999;
    }

    decrease() {
      var current = parseInt(this.input.value) || this.min;
      var newVal = Math.max(current - 1, this.min);
      if (newVal !== current) {
        this.input.value = newVal;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    increase() {
      var current = parseInt(this.input.value) || this.min;
      var newVal = Math.min(current + 1, this.max);
      if (newVal !== current) {
        this.input.value = newVal;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    validate() {
      var val = parseInt(this.input.value);
      if (isNaN(val) || val < this.min) {
        this.input.value = this.min;
      } else if (val > this.max) {
        this.input.value = this.max;
      }
    }
  }

  customElements.define('quantity-input', QuantityInput);
})();
